import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';

import { useState } from 'react';
import { CopyButton } from '~/components/CopyInputButton';
import { InlineCode } from '~/components/InlineCode';
interface ApiKeyCardProps {
  apiKey: string;
}
export const ApiKeyCard = ({ apiKey }: ApiKeyCardProps) => {
  const [hidden, setHidden] = useState(true);
  return (
    <Box>
      <Typography
        component="label"
        htmlFor="api-key"
        variant="subtitle2"
        fontWeight={500}
        display="block"
        sx={{ mb: 1 }}>
        Your API key
      </Typography>
      <TextField
        id="api-key"
        value={apiKey}
        type={hidden ? 'password' : 'text'}
        fullWidth
        slotProps={{
          input: {
            readOnly: true,
            sx: { fontFamily: hidden ? undefined : 'monospace' },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  title={hidden ? 'Show API key' : 'Hide API key'}
                  onClick={() => {
                    setHidden(!hidden);
                  }}
                  sx={{ mr: 1 }}>
                  {hidden ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
                <CopyButton value={apiKey} variant="outlined" size="large">
                  Copy
                </CopyButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        sx={{ mt: 1 }}>
        Send it as an <InlineCode>api_key</InlineCode> header on every request.
        Keep it private.
      </Typography>
    </Box>
  );
};
